import { render, staticRenderFns } from "./DxProducts.vue?vue&type=template&id=2a6c8762&"
import script from "./DxProducts.vue?vue&type=script&lang=js&"
export * from "./DxProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports